module.exports = __webpack_public_path__ + "img/mexico.28416abd.jpg";